export default {
  methods: {
    getStatusIcon: function (status) {
      if (status === 'NOT_INUSE') {
        return 'call_end'
      }
      if (status === 'RINGING' || status === 'RINGINUSE') {
        return 'ring_volume'
      }
      if (status === 'INUSE' || status === 'BUSY') {
        return 'phone_in_talk'
      }
      if (status === 'ONHOLD') {
        return 'phone_paused'
      }
      return 'remove_circle_outline'
    }
  }
}
